<template>
    <div class="download-content">
        <div class="tab">
            <div :class="['tab-item', tab.class, curTabVersion === tab.key ? 'active' : '']" v-for="tab in tabList" :key="tab.key" @click="changeTab(tab.key)">{{tab.name}}</div>
        </div>
        <!-- 套餐下载 -->
        <template v-if="activeTab === 'packageDown'">
            <packageDown
                :item="versionData"
                :type="curTabVersion"
                :active-tab="activeTab"
                @recordUserDownload="recordUserDownload"
                @containerDeployValidate="containerDeployValidate">
            </packageDown>
        </template>
        <!-- 版本列表 -->
        <template v-else>
            <versionList
                :item="versionData"
                :type="curTabVersion"
                @recordUserDownload="recordUserDownload"
                @containerDeployValidate="containerDeployValidate">
            </versionList>
        </template>
    </div>
</template>

<script>
import packageDown from './packageDown.vue'
import versionList from './versionList.vue'
export default {
    name: 'downloadContent',
    components: {
        packageDown,
        versionList
    },
    props: {
        activeTab: String,
        loading: Boolean,
        item: Object
    },
    data () {
        return {
            curTabVersion: '',
            versionData: {
                title: {},
                basic: {}, // 基础套餐
                combos: []
            },
            tabList: [
                { name: '容器化版本', key: 'containerize', class: 'tab-item-left' },
                { name: '二进制版本', key: 'binary', class: 'tab-item-right'}
            ]
        }
    },
    watch: {
        item: {
            handler (val) {
                this.setVersionData(val)
            },
            deep: true
        },
        activeTab (val) {
            this.setVersionData(this.item)
            this.changeTab(this.$route.query.version || 'containerize')
        },
    },
    mounted () {
        this.curTabVersion = this.$route.query.version || 'containerize'
    },
    methods: {
        recordUserDownload (cur) {
            this.$emit('recordUserDownload', cur)
        },
        containerDeployValidate (cur) {
            this.$emit('containerDeployValidate', cur)
        },
        changeTab (version) {
            this.curTabVersion = version
            this.setVersionData(this.item)
            this.$router.push({
                path: '/s-mart/downloads',
                query: {
                    type: this.activeTab,
                    version
                }
            })
        },
        setVersionData (item) {
            this.clearInfo()
            const versionMap = {
                binary: '二进制版本',
                containerize: '容器化版本'
            }
            const versionData = item.children.find(v => v.name === versionMap[this.curTabVersion])
            versionData.children.forEach(v => {
                if (v.name === '套餐所属版本') {
                    v.cname = v.name + '：'+ v.extra_info.version.split(' ')[0]
                    v.version = ' ' + v.extra_info.version.split(' ')[1]
                    v.release = v.extra_info.release
                    this.versionData.title = v
                } else if (v.name === '基础套餐') {
                    v.size = v.extra_info.size
                    v.md5 = v.extra_info.md5
                    this.versionData.basic = v
                } else {
                    this.versionData.combos.push(v)
                }
            })
        },
        clearInfo () {
            this.versionData.title = {}
            this.versionData.basic = {}
            this.versionData.combos = []
        }
    }
}
</script>

<style lang="scss" scoped>
.download-content {
    width: 1200px;
    margin: 0 auto;
    .tab {
        width: 560px;
        height: 40px;
        line-height: 40px;
        margin: 24px auto;
        .tab-item {
            &:hover {
                border-color: #3A84FF;
                color: #3A84FF;
            }
        }
        .tab-item-left {
            width: 280px;
            width: 280px;
            height: 40px;
            text-align: center;
            background: #FFF;
            border: 1px solid #C4C6CC;
            border-right: none;
            border-radius: 2px 0px 0px 2px;
            float: left;
            cursor: pointer;
        }
        .tab-item-right {
            width: 280px;
            width: 280px;
            height: 40px;
            text-align: center;
            background: #FFF;
            border: 1px solid #C4C6CC;
            border-left: none;
            border-radius: 0 2px 2px 0;
            float: left;
            cursor: pointer;
        }
        .active {
            border: 1px solid #3A84FF;
            background: #E1ECFF;
            color: #3A84FF;
        }
    }
}
</style>


// WEBPACK FOOTER //
// downloadContent.vue?8db7c50a